import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import styles from "./auth-styles.module.css";

type Props = {
  label: string;
  disabled: boolean;
  loading: boolean;
};

const AuthActionButton = ({ label, disabled, loading }: Props) => {
  return (
    <Button
      type="submit"
      label={label}
      disabled={disabled}
      loading={loading}
      className={classNames(styles.mainButton, "border-noround")}
      pt={{
        label: { className: "font-semibold" },
      }}
    />
  );
};

export default AuthActionButton;
